import { render, staticRenderFns } from "./add2to4weeksChecking.vue?vue&type=template&id=56b16a78&"
import script from "./add2to4weeksChecking.vue?vue&type=script&lang=js&"
export * from "./add2to4weeksChecking.vue?vue&type=script&lang=js&"
import style0 from "./add2to4weeksChecking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports